/**
 * The drug test reasons, in the order step 2 offers them — the same list and the same keys the
 * server holds in OnboardingStep2Reference.DrugTestReasons (bug 6365).
 *
 * The keys are the stable codes the Imperans import request sends, which Imperans resolves to a
 * TestReasonID. The seven codes the CRM invented before ("PE", "IT", "PI", "RC", "R", "RR", "RSM")
 * resolved to nothing there; the server upgrades a stored notification scope from them on read, and
 * the Epic 6303 data script moves the stored contact rows.
 *
 * Used by the contact grid and the contact dialog for a contact's result-notification scope, so it
 * offers the same reasons the testing services do (bug 5699).
 */
export const TESTING_OCCASIONS: { key: string; label: string }[] = [
  { key: "PRE_EMPLOYMENT", label: "Pre employment" },
  { key: "INTERNAL_TRANSFER", label: "Internal Transfer" },
  { key: "POST_INCIDENT", label: "Post Incident" },
  { key: "REASONABLE_CAUSE", label: "Reasonable Cause" },
  { key: "RANDOM", label: "Random" },
  { key: "RETURN_TO_WORK", label: "Return to work" },
  { key: "RE_TEST", label: "Re-Test" },
  { key: "RANDOM_REHAB", label: "Random Rehab" },
  { key: "DEPLOYMENT", label: "Deployment" },
  { key: "VOLUNTARY", label: "Voluntary" },
  { key: "COMPLIANCE", label: "Compliance" },
  { key: "OTHER", label: "Other" },
];
